// @flow

import * as React from "react";

import "./Header.css";

type Props = {
  children?: React.Node
};

const Header = (props: Props) => <div className="Header">{props.children}</div>;

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js